import React from 'react'

import '../../styles/table/index.scss'

const Table = ({ children }) => <ul className="detailed-table">{children}</ul>

export default Table
